module.exports = __webpack_public_path__ + "static/media/CH.9e517960.wav";